import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { CalendarModule } from 'primeng/calendar';
import { TableModule } from 'primeng/table';
import { HttpClientModule } from '@angular/common/http';
import { MatMenuModule } from '@angular/material/menu';
import { NgxPicaModule, NgxPicaService } from 'ngx-pica';
import { ChartModule } from 'primeng/primeng';

//https://www.npmjs.com/package/angular2-qrcode
import { QRCodeModule } from 'angular2-qrcode';

import { AppComponent } from './app.component';
import { AccountComponent } from './account/account.component';
import { GiveawayGenComponent } from './GiveawayGen/GiveawayGen.component';
import { LoginComponent } from './account/login/login.component';
import { RegisterComponent } from './account/register/register.component';
import { NavComponent } from './nav/nav.component';
import { HomeComponent } from './home/home.component';
import { InventoryManagerComponent } from './inventory-manager/inventory-manager.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AddInventoryComponent } from './inventory-manager/add-inventory/add-inventory.component';
import { AddMultipleInventoryComponent } from './inventory-manager/add-multiple-inventory/add-multiple-inventory.component';
import { AddDetailsComponent } from './inventory-manager/add-details/add-details.component';
import { PrintIdCardsComponent } from './inventory-manager/print-id-cards/print-id-cards.component';
import { ViewInventoryComponent } from './inventory-manager/view-inventory/view-inventory.component';
import { EditInventoryComponent } from './inventory-manager/edit-inventory/edit-inventory.component';
import { AdminModuleComponent } from './admin-module/admin-module.component';
import { TicketsComponent } from './admin-module/tickets/tickets.component';
import { TableManagementComponent } from './admin-module/table-management/table-management.component';
import { ContactComponent } from './contact/contact.component';
import { PwrComponent } from './pwr/pwr.component';
import { ForgotPasswordComponent } from './account/forgot-password/forgot-password.component';
import { ForgotUsernameComponent } from './account/forgot-username/forgot-username.component';

import { AuthServiceService } from './services/auth-service.service';
import { DetailsService } from './services/details.service';
import { InventoryService } from './services/inventory.service';
import { SendMailService } from './services/sendmail.service';
import { DashboardService } from './services/dashboard.service';

//import { HashLocationStrategy, LocationStrategy } from '@angular/common';


const appRoutes: Routes = [
 {path:'account', component: AccountComponent},
 {path:'login',component: LoginComponent},
 {path:'home', component: HomeComponent},
 {path:'inventory-manager', component: InventoryManagerComponent},
 {path:'register', component: RegisterComponent},
 {path:'giveaway', component: GiveawayGenComponent},
 {path:'dashboard', component: DashboardComponent},
 {path:'view-inventory/:id', component: ViewInventoryComponent},
 {path:'edit-inventory/:id', component: EditInventoryComponent},
 {path:'add-inventory', component: AddInventoryComponent},
 {path:'add-multiple-inventory', component: AddMultipleInventoryComponent},
 {path:'add-details', component: AddDetailsComponent},
 {path:'add-details/:id', component: AddDetailsComponent},
 {path:'add-details/:id/:grp', component: AddDetailsComponent},
 {path:'print-id-cards', component: PrintIdCardsComponent},
 {path:'admin-module', component: AdminModuleComponent},
 {path:'tickets', component: TicketsComponent},
 {path:'table-management', component: TableManagementComponent},
 {path:'contact', component: ContactComponent},
 {path:'sendMail', component: SendMailService},
 {path:'pwr/:id', component: PwrComponent},
 {path:'forgot-password', component: ForgotPasswordComponent},
 {path:'forgot-username', component: ForgotUsernameComponent},
 {path:'**', component: HomeComponent},
];

@NgModule({
  declarations: [
    AppComponent,
    AccountComponent,
    LoginComponent,
    RegisterComponent,
    NavComponent,
    InventoryManagerComponent,
    HomeComponent,
    DashboardComponent,
    ViewInventoryComponent,
    AddInventoryComponent,
    AddMultipleInventoryComponent,
    AddDetailsComponent,
    PrintIdCardsComponent,
    EditInventoryComponent,
    GiveawayGenComponent,
    AdminModuleComponent,
    TicketsComponent,
    TableManagementComponent,
    ContactComponent,
    PwrComponent,
    ForgotPasswordComponent,
    ForgotUsernameComponent
  ],
  imports: [
  RouterModule.forRoot(
      appRoutes,
      { useHash: true } 
    ),
    BrowserModule,
    FormsModule,
    BrowserAnimationsModule,
    CalendarModule,
    HttpClientModule,
    MatMenuModule,
    TableModule,
    QRCodeModule,
    NgxPicaModule,
    ChartModule
  ],
  providers: [
    AuthServiceService,
    DetailsService,
    InventoryService,
    SendMailService,
    NgxPicaService,
    DashboardService
  ],
  bootstrap: [AppComponent],
  exports: [
    RouterModule
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts